import { useQuery } from 'react-query';
import { QueryKey } from 'src/models/query';
import { useAPIs } from 'src/hooks/useAPIs';
import { APIs } from 'src/models/apis';
import { translateItemFactory } from 'src/hooks/directus/useTranslateItem';
import { FilterDescription, FilterType } from 'src/components/filters/types';
import { videoSearchFiltersGqlQuery } from 'src/modules/videos/graphql/videos-search-filters.query';

export const fetchVideosShowcaseFilters = async (
  apis: APIs,
): Promise<FilterDescription[]> => {
  const translateItem = translateItemFactory(
    apis.language.getCurrentLanguage(),
  );

  const directus = await apis.directus();
  const data = await directus.query(videoSearchFiltersGqlQuery);

  return [
    {
      title: 'Subject',
      queryField: 'subject',
      type: FilterType.Multiselect,
      options: data.subjects.map(translateItem).map((s) => ({
        label: s.name,
        value: s.slug,
      })),
    },
    {
      title: 'Face Part',
      queryField: 'bodyPart',
      type: FilterType.Facepart,
      options: data.bodyParts.map((s) => ({
        label: s.slug,
        value: s.slug,
      })),
    },
    {
      title: 'Tags',
      queryField: 'tag',
      type: FilterType.Tags,
      options: data.tags.map(translateItem).map((s) => ({
        label: s.name,
        value: s.slug,
      })),
    },
    {
      title: 'Duration',
      queryField: 'duration',
      type: FilterType.Multiselect,
      options: data.durations.map(translateItem).map((s) => ({
        label: s.name,
        value: s.slug,
      })),
    },
    {
      title: 'Audio Language',
      queryField: 'audioLanguage',
      type: FilterType.Language,
      options: data.languages.map((s) => ({
        label: s.name,
        value: s.code,
      })),
    },
    {
      title: 'Subtitle Language',
      queryField: 'subtitleLanguage',
      type: FilterType.Language,
      options: data.languages.map((s) => ({
        label: s.name,
        value: s.code,
      })),
    },
  ];
};

export const useVideosShowcaseFiltersQuery = () => {
  const apis = useAPIs();
  return useQuery(QueryKey.VideoSearchFilters, () =>
    fetchVideosShowcaseFilters(apis),
  );
};
